import { capitalizeFirstLetter } from 'utils/GlobalHelpers';

const cognitoLike = /cognito|notauthorized|codemismatch|expiredcode|softwaretoken/i;

function safeApiMessage(message: unknown): string | null {
  if (typeof message !== 'string' || !message.trim()) {
    return null;
  }
  if (cognitoLike.test(message)) {
    return null;
  }
  return capitalizeFirstLetter(message);
}

/** User-facing copy for auth/MFA API failures without exposing raw provider errors. */
function mapAuthApiError(error: any, fallback = 'Something went wrong. Please try again.'): string {
  const status = error?.response?.status;
  const fromApi = safeApiMessage(error?.response?.data?.message);
  if (fromApi) {
    return fromApi;
  }
  if (status === 401) {
    return 'That did not work. Check your details and try again.';
  }
  if (status === 400) {
    return 'Invalid or expired request. Try again or start over from the sign-in page.';
  }
  return fallback;
}

export default mapAuthApiError;
